import { ResponseType } from "../../Types/ServicesType/servicesType";
import { DailyRevenueReportType, ParamsType } from "./type";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId} = getConstants()
const {reportsApi} = api

export const dailyRevenueReportSearch = async (params:ParamsType):Promise<ResponseType<DailyRevenueReportType[]>> => {
  const response = await instance.post(`${reportsApi.dailyRevenueReport}`, { ...params,clinicId });
  return response.data;
};

export const dailyRevenueReportPdf = async (params:ParamsType):Promise<ResponseType<{file:string | null}>>=>{
  const response = await instance.post(`${reportsApi.dailyRevenueReportPdf}`, { ...params,clinicId });
  return response.data;
}
export const dailyRevenueReportExcel = async (params:ParamsType):Promise<ResponseType<string | null>>=>{
  const response = await instance.post(`${reportsApi.dailyRevenueReportExcel}`, { ...params,clinicId });
  return response.data;
}
